const getters = {
    getAutenticacao: state => state.autenticacao,
    getCentroCusto: state => state.centroCusto,
    getCliente: state => state.cliente,
    getCustomer: state => state.customer,
    getFila: state => state.fila,
    getLoading: state => state.loading,
    getLotacao: state => state.lotacao,
    getMenu: state => state.menu,
    getQuantidadeNotasVersaoNovas: state => state.quantidadeNotasVersaoNovas,
    getQuantidadeNotificacoesNaoLidas: state => state.quantidadeNotificacoesNaoLidas,
    getRouterInfo: state => state.routerInfo,
    getShowExitFormConfirmation: state => state.showExitFormConfirmation,
    getSidebar: state => state.sidebar,
}

export default getters